import 'uswds';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
// This polyfill gives us more control over smooth scrolling throughout the application
import smoothscroll from 'smoothscroll-polyfill';
import Main from './components/Main/Main';
import store from './services/store';
import tabology from './plugins/tabology';
import './eqip.scss';

smoothscroll.polyfill();

const targetNode = document.getElementsByTagName('body')[0];
const config = { attributes: true };
const callback = (mutationList) => {
  tabology();
};
const observer = new MutationObserver(callback);
observer.observe(targetNode, config);

const components = (
  <Provider store={store}>
    <Main />
  </Provider>
);
const app = document.getElementById('app');

ReactDOM.render(components, app, tabology);
